import {React} from 'common'
import {validationPatterns} from 'constants/auth'
import {FormContainer, FormTitle} from 'components/Control/Form'
import FormTextInput from 'components/Control/Form/FormTextInput'

function ResetPasswordForm({translate, control, errors}) {
    return (
        <FormContainer>
            <FormTitle>{translate('resetPassword')}</FormTitle>
            <FormTextInput
                name={'email'}
                control={control}
                rules={{
                    required: true,
                    pattern: validationPatterns.EMAIL,
                }}
                fullWidth
                label={translate('email')}
                type="email"
                errors={errors}
            />
        </FormContainer>
    )
}

export default ResetPasswordForm
